// The Halloween jack-o'-lantern by the door (studio/ART-BIBLE.md: orange #f08a2c only during the event).
// Pixel art as rows: k ink, o orange, w paper (the candle through the carving), . clear. Two frames, lit and
// guttering; the candle steps between them at 15 fps, never a smooth fade. Pure apart from mountJack.
export const ORANGE = '#f08a2c';
export const JACK_COLOURS = { k: '#000000', o: ORANGE, w: '#ffffff' };
export const JACK = {
  lit: [
    '..........kk........',
    '.........kk.........',
    '.....kkkkkkkkkk.....',
    '...kkookooookookk...',
    '..koookooooookoook..',
    '.kooookooooookooook.',
    'kooowokooooookowoook',
    'koowwwkooooookwwwook',
    'koooookooooookoooook',
    'koooookoowwookoooook',
    'koowookooooookoowook',
    'koowwwwowwwwowwwwook',
    '.kooowwwwoowwwwoook.',
    '..koookooooookoook..',
    '...kkookooookookk...',
    '.....kkkkkkkkkk.....',
  ],
  dim: [
    '..........kk........',
    '.........kk.........',
    '.....kkkkkkkkkk.....',
    '...kkookooookookk...',
    '..koookooooookoook..',
    '.kooookooooookooook.',
    'koookokooooookokoook',
    'kookwkkooooookkwkook',
    'koooookooooookoooook',
    'koooookookkookoooook',
    'kookookooooookookook',
    'kookkkkowkkwokkkkook',
    '.koookwkkookkwkoook.',
    '..koookooooookoook..',
    '...kkookooookookk...',
    '.....kkkkkkkkkk.....',
  ],
};
export const JACK_W = 20, JACK_H = 16, FPS = 15;

// Which frame the candle shows on 15 fps frame f: mostly lit, a short gutter now and then.
export function candleFrame(f) {
  let h = Math.imul((f >> 1) ^ 0x5bd1e995, 0x27d4eb2d); h ^= h >>> 15;
  return ((h >>> 0) % 100) < 12 ? 'dim' : 'lit';
}

// Paint one frame through a pixel setter px(x, y, '#rrggbb').
export function paintJack(px, frame = 'lit') {
  JACK[frame].forEach((row, y) => [...row].forEach((c, x) => { if (c !== '.') px(x, y, JACK_COLOURS[c]); }));
}

// A 1-px paper rim around the drawing (every clear cell that touches it, diagonals too), so the ink stem and
// outline still read against the black wall. The rimmed jack is (JACK_W + 2) x (JACK_H + 2), the drawing at 1,1.
export const RIM = 1, RIM_W = JACK_W + 2 * RIM, RIM_H = JACK_H + 2 * RIM;
const solid = (frame, x, y) => y >= 0 && y < JACK_H && x >= 0 && x < JACK_W && JACK[frame][y][x] !== '.';
export function paintJackRimmed(px, frame = 'lit') {
  for (let y = -RIM; y < JACK_H + RIM; y++) for (let x = -RIM; x < JACK_W + RIM; x++) {
    if (solid(frame, x, y)) continue;
    let touch = false;
    for (let j = -1; j <= 1 && !touch; j++) for (let i = -1; i <= 1; i++) if (solid(frame, x + i, y + j)) { touch = true; break; }
    if (touch) px(x + RIM, y + RIM, JACK_COLOURS.w);
  }
  paintJack((x, y, c) => px(x + RIM, y + RIM, c), frame);
}

// Browser: draw into a canvas inside #jack (halloween.css shows it only under body.halloween).
export function mountJack(el, { doc = document, reduceMotion = false } = {}) {
  if (!el) return null;
  const c = doc.createElement('canvas'); c.width = RIM_W; c.height = RIM_H;
  el.replaceChildren(c);
  const g = c.getContext('2d');
  let shown = null;
  const show = frame => {
    if (frame === shown) return;
    shown = frame; g.clearRect(0, 0, RIM_W, RIM_H);
    paintJackRimmed((x, y, col) => { g.fillStyle = col; g.fillRect(x, y, 1, 1); }, frame);
  };
  show('lit');
  if (!reduceMotion) setInterval(() => { if (doc.body.classList.contains('halloween')) show(candleFrame(Math.floor(performance.now() / 1000 * FPS))); }, 1000 / FPS);
  return c;
}

if (typeof document !== 'undefined') {
  const el = document.getElementById('jack');
  if (el) mountJack(el, { reduceMotion: matchMedia('(prefers-reduced-motion: reduce)').matches });
}
